// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Card, Typography, makeStyles} from '@material-ui/core';
import {ArrowForwardIos, Check} from '@material-ui/icons';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';

const useStyles = makeStyles(theme => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    borderRadius: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f9f9fb',
    marginTop: '1rem',
    position: 'relative',
    minHeight: '300px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  cardState: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    gap: '10px',
    top: 10,
    left: 10,
    height: 24,
  },

  cardStateText: {
    fontSize: '0.9rem',
  },
  cardStateTextActivate: {
    color: '#000',
  },
  cardStateTextDeactivate: {
    color: '#9c9daf',
  },
  cardImg: {
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80px',
    height: '80px',
  },
  titleCenter: {
    textAlign: 'center',
    fontWeight: 600,
  },
  textCenter: {
    textAlign: 'center',
    color: theme.palette.grey[800],
  },
  startIcon: {
    margin: 0,
  },
  buttonActivate: {
    backgroundColor: '#10b981',
    color: '#fff',
    width: '25px',
    height: '25px',
    borderRadius: '50%',

    '&:hover': {
      backgroundColor: '#10b981',
    },
  },
  buttonDeactivate: {
    backgroundColor: '#d1d1db',
    color: '#fff',
    width: '25px',
    height: '25px',
    borderRadius: '50%',
    boxShadow: 'inset 0px 0px 1px rgb(52, 52, 54, 0.5)',
    '&:hover': {
      backgroundColor: '#d1d1db',
    },
  },
}));

type Props = {
  enabled: boolean,
  componentImg: () => any,
  title: string,
  description: string,
  to: string,
  typeRate: string,
  handleOpenModalActivate: () => void,
  setTypeRateSelected: (typeRate: string) => void,
};
export default function CardRateShipping(props: Props) {
  const {
    enabled,
    componentImg,
    title,
    description,
    to,
    typeRate,
    handleOpenModalActivate,
    setTypeRateSelected,
  } = props;
  const classes = useStyles();

  const checkedCheckbox = <Check style={{fontSize: '1.2rem'}} />;

  const showModalActivateRate = () => {
    if (enabled) return;
    setTypeRateSelected(typeRate);
    handleOpenModalActivate();
  };

  return (
    <Card className={classes.card}>
      <div className={classes.cardState}>
        <CustomButton
          classes={{
            root: enabled ? classes.buttonActivate : classes.buttonDeactivate,
          }}
          onClick={showModalActivateRate}
        >
          <React.Fragment>{enabled ? checkedCheckbox : null}</React.Fragment>
        </CustomButton>
        <Typography
          className={`${classes.cardStateText} ${
            enabled
              ? classes.cardStateTextActivate
              : classes.cardStateTextDeactivate
          }`}
        >
          {enabled ? 'Activo' : 'Inactivo'}
        </Typography>
      </div>
      <div className={classes.cardImg}>{React.createElement(componentImg)}</div>
      <Typography className={classes.titleCenter}>{title}</Typography>
      <p className={classes.textCenter}>{description}</p>
      <CustomButton
        endIcon={<ArrowForwardIos />}
        color="primary"
        variant="text"
        to={to}
      >
        Configurar
      </CustomButton>
    </Card>
  );
}

CardRateShipping.prototype = {
  enabled: PropTypes.bool,
  componenteImg: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  handleOpenModalActivate: PropTypes.func,
  to: PropTypes.string,
  typeRate: PropTypes.string,
  setTypeRateSelected: PropTypes.func,
};
